import React, { Component } from "react";

import powered_by_gametize from "images/core/home/powered-by-gametize-black.png";

class LoginImageRow extends Component {
  render() {
    return (
      <div className="innerblock pure-g justify-content-center">
        <a
          href="https://www.gametize.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={powered_by_gametize}
            className="login-powered-by-image"
            alt=""
          />
        </a>
      </div>
    );
  }
}

export default LoginImageRow;
